'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    ', ';\n    position: relative;\n    padding-bottom: 44px;\n    .city-state-zip {\n        float: left;\n        width: 100%;\n        \n        ', '\n    }\n    \n    .restaurant {\n        float: left;\n        width: 100%;\n        \n        ', '\n    }\n'], ['\n    ', ';\n    position: relative;\n    padding-bottom: 44px;\n    .city-state-zip {\n        float: left;\n        width: 100%;\n        \n        ', '\n    }\n    \n    .restaurant {\n        float: left;\n        width: 100%;\n        \n        ', '\n    }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n            width: 50%;\n        '], ['\n            width: 50%;\n        ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n            width: 40%;\n        '], ['\n            width: 40%;\n        ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    \n'], ['\n    \n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding-top: 11px;\n    ', '\n'], ['\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding-top: 11px;\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n        width: 10%;\n    '], ['\n        width: 10%;\n    ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    height: 45px;\n    position: relative;\n    padding-left: 20px;\n    background: #FFFFFF;\n    border: 1px solid #C5B3AF;\n    border-radius: 2px 0 0 2px;\n    border-right: none;\n    width: calc(100% - 100px);\n    font: inherit;\n    \n    &::-webkit-input-placeholder { font-size: .7em; }\n    &::-moz-placeholder { font-size: .7em; }\n    &:-ms-input-placeholder { font-size: .7em; }\n'], ['\n    height: 45px;\n    position: relative;\n    padding-left: 20px;\n    background: #FFFFFF;\n    border: 1px solid #C5B3AF;\n    border-radius: 2px 0 0 2px;\n    border-right: none;\n    width: calc(100% - 100px);\n    font: inherit;\n    \n    &::-webkit-input-placeholder { font-size: .7em; }\n    &::-moz-placeholder { font-size: .7em; }\n    &:-ms-input-placeholder { font-size: .7em; }\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n    background: #8B7166;\n    border-width: 0;\n    border-radius: 0 2px 2px 0;\n    font-size: 13px;\n    color: #FFFFFF;\n    letter-spacing: 0;\n    font-family: ', '\n    text-transform: uppercase;\n    width: 100px;\n    margin: 0;\n    padding: 0;\n    height: 45px;\n    :first-child {\n        width: 20px;\n    }\n    img {\n        padding-right: 5px;\n    }\n'], ['\n    background: #8B7166;\n    border-width: 0;\n    border-radius: 0 2px 2px 0;\n    font-size: 13px;\n    color: #FFFFFF;\n    letter-spacing: 0;\n    font-family: ', '\n    text-transform: uppercase;\n    width: 100px;\n    margin: 0;\n    padding: 0;\n    height: 45px;\n    :first-child {\n        width: 20px;\n    }\n    img {\n        padding-right: 5px;\n    }\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n    display: ', ';\n    position: absolute;\n    z-index: 1;\n    top: 46px;\n    width: calc(100% - 100px);\n    background: #FFFFFF;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    padding-left: 10px;\n    \n    ', '\n'], ['\n    display: ', ';\n    position: absolute;\n    z-index: 1;\n    top: 46px;\n    width: calc(100% - 100px);\n    background: #FFFFFF;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    padding-left: 10px;\n    \n    ', '\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n        width: 280px;\n    '], ['\n        width: 280px;\n    ']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n    font-style: italic;\n    font-size: 12px;\n    color: #8B7166;\n    letter-spacing: 0;\n    line-height: 20px;\n'], ['\n    font-style: italic;\n    font-size: 12px;\n    color: #8B7166;\n    letter-spacing: 0;\n    line-height: 20px;\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n    cursor: pointer;\n    letter-spacing: 0;\n    line-height: 26px;\n'], ['\n    cursor: pointer;\n    letter-spacing: 0;\n    line-height: 26px;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var SearchBarStyled = _styledComponents2.default.div(_templateObject, (0, _styledComponentsHelper.clearfix)(), _styledComponentsHelper.media.md(_templateObject2), _styledComponentsHelper.media.md(_templateObject3));

var StyledForm = _styledComponents2.default.form(_templateObject4);

var StyledOr = _styledComponents2.default.div(_templateObject5, _styledComponentsHelper.media.md(_templateObject6));

var InputStyled = _styledComponents2.default.input(_templateObject7);

var SearchButtonStyled = _styledComponents2.default.button(_templateObject8, _styledComponentsHelper.fontFamilies.bold);

var LocationSuggestionsStyled = _styledComponents2.default.div(_templateObject9, function (props) {
    return props.show ? 'inherit' : 'none';
}, _styledComponentsHelper.media.md(_templateObject10));

var SuggestionTextStyled = _styledComponents2.default.div(_templateObject11);

var LocationSuggestion = _styledComponents2.default.div(_templateObject12);

var SearchBar = function (_Component) {
    _inherits(SearchBar, _Component);

    function SearchBar(props) {
        _classCallCheck(this, SearchBar);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.suggestedLocationToggle = function (e) {
            if (!document.getElementById('location-suggestions').contains(e.target) && _this.props.locationSuggestions.length) {
                _this.props.clearLocationSuggestions();
            }
        };

        _this.onEnter = function (event) {
            if (event.keyCode === 13) {
                var target = event.currentTarget.id.replace('entry', 'submit');
                document.getElementById(target).click();
            }
        };

        _this.setInputValue = function (event) {
            var target = event.currentTarget.id || 'csz-entry';
            var value = event.currentTarget.value;

            var propsForUpdate = target === 'csz-entry' ? { inputVal: value, inputValSiteNumber: '' } : { inputVal: '', inputValSiteNumber: value };

            _this.setState(propsForUpdate);
        };

        _this.handleSearchButtonClick = function (event) {
            event.preventDefault();

            var isSiteNumberSearch = event.currentTarget.id === 'site-number-submit';
            var searchValue = isSiteNumberSearch ? _this.state.inputValSiteNumber : _this.state.inputVal;
            var isValidSearchContext = searchValue && searchValue.length > 0;

            if (isValidSearchContext && _this.props.onSearch) {
                _this.props.onSearch(searchValue, isSiteNumberSearch);
            }
        };

        _this.state = {
            inputVal: '',
            inputValSiteNumber: '',
            cityStateZip: '',
            restaurantId: ''
        };
        return _this;
    }

    SearchBar.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('click', this.suggestedLocationToggle);
    };

    SearchBar.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('click', this.suggestedLocationToggle);
    };

    SearchBar.prototype.render = function render() {
        var _this2 = this;

        return _react2.default.createElement(
            SearchBarStyled,
            { className: 'search-controls' },
            _react2.default.createElement(
                StyledForm,
                { className: 'city-state-zip', onSubmit: function onSubmit(e) {
                        return e.preventDefault();
                    } },
                _react2.default.createElement(InputStyled, { id: 'csz-entry',
                    onKeyDown: this.onEnter,
                    onChange: this.setInputValue,
                    type: 'text',
                    placeholder: !this.state.inputVal ? this.props.getLocalizedText('RestaurantCSZ', 'Enter City, State, or Zipcode') : '',
                    value: this.state.inputVal,
                    'aria-label': !this.state.inputVal ? this.props.getLocalizedText('RestaurantCSZ', 'Enter City, State, or Zipcode') : '',
                    'aria-autocomplete': 'list',
                    title: 'Search' }),
                _react2.default.createElement(
                    SearchButtonStyled,
                    { id: 'csz-submit',
                        type: 'button',
                        'aria-label': 'Press enter to search',
                        onClick: this.handleSearchButtonClick },
                    _react2.default.createElement('img', { src: '/images/common/icons/ic_search.svg' }),
                    _react2.default.createElement(
                        'span',
                        { className: ' hidden-xs-search' },
                        'Search'
                    )
                )
            ),
            _react2.default.createElement(
                StyledOr,
                null,
                'OR'
            ),
            _react2.default.createElement(
                StyledForm,
                { className: 'restaurant', onSubmit: function onSubmit(e) {
                        return e.preventDefault();
                    } },
                _react2.default.createElement(InputStyled, { id: 'site-number-entry',
                    onKeyDown: this.onEnter,
                    onChange: this.setInputValue,
                    type: 'text',
                    placeholder: !this.state.inputValSiteNumber ? this.props.getLocalizedText('RestaurantNumber', 'Enter Restaurant Number') : '',
                    value: this.state.inputValSiteNumber,
                    'aria-label': !this.state.inputValSiteNumber ? this.props.getLocalizedText('RestaurantNumber', 'Enter Restaurant Number') : '',
                    'aria-autocomplete': 'list',
                    title: 'Search' }),
                _react2.default.createElement(
                    SearchButtonStyled,
                    { id: 'site-number-submit',
                        type: 'button',
                        'aria-label': 'Press enter to search',
                        onClick: this.handleSearchButtonClick },
                    _react2.default.createElement('img', { src: '/images/common/icons/ic_search.svg' }),
                    _react2.default.createElement(
                        'span',
                        { className: ' hidden-xs-search' },
                        'Search'
                    )
                )
            ),
            _react2.default.createElement(
                LocationSuggestionsStyled,
                { id: 'location-suggestions', show: !!this.props.locationSuggestions.length },
                _react2.default.createElement(
                    SuggestionTextStyled,
                    null,
                    'No Results Found, Suggested Searches'
                ),
                this.props.locationSuggestions.slice(0, 5).map(function (location, idx) {
                    return _react2.default.createElement(
                        LocationSuggestion,
                        { key: 'suggested_Location_' + idx, onClick: function onClick() {
                                _this2.handleLocationSuggestionSelection(location.address2);
                            } },
                        location.address2
                    );
                })
            )
        );
    };

    SearchBar.prototype.handleLocationSuggestionSelection = function handleLocationSuggestionSelection(selectedAddress) {
        this.setState({ inputVal: selectedAddress, inputValSiteNumber: '' }, function () {
            document.getElementById('csz-submit').click();
        });
    };

    return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
    locationSuggestions: _propTypes2.default.array,
    onSearch: _propTypes2.default.func,
    clearLocationSuggestions: _propTypes2.default.func,
    getLocalizedText: _propTypes2.default.func,
    locale: _propTypes2.default.shape({
        country: _propTypes2.default.string,
        language: _propTypes2.default.string,
        localeCode: _propTypes2.default.string
    })
};

SearchBar.defaultProps = {
    locationSuggestions: [],
    onSearch: function onSearch() {},
    clearLocationSuggestions: function clearLocationSuggestions() {},
    getLocalizedText: function getLocalizedText(key, defaultValue) {
        return defaultValue;
    },
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

exports.default = SearchBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/SearchBar/index.js
// module id = 834
// module chunks = 0